"use strict";

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Dashboard
 * (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var underscore_1 = require("underscore");

var ConditionalFormattingAPI_1 = __importDefault(require("./ConditionalFormattingAPI"));

var UIConditionalFormattingAPI_1 = __importDefault(require("./internal/UIConditionalFormattingAPI"));

var ConditionalFormattingAPISpec_1 = __importDefault(require("./ConditionalFormattingAPISpec"));

var APIFactory_1 = __importDefault(require("./internal/APIFactory"));

var StringResources_1 = __importDefault(require("../nls/StringResources")); // @TODO Currently have to use relative path when inlude Js files during the webpacking phase
// Need to investigate to be able to use absolute path


var RuleConstants_1 = require("../definitions/constants/RuleConstants");

var IconsMap_1 = __importDefault(require("../definitions/constants/IconsMap"));

var Actions_1 = require("../definitions/constants/Actions"); // React State Model


var ConditionalFormattingState_1 = __importDefault(require("../stateModel/ConditionalFormattingState"));

var MeasureDataItem_1 = __importDefault(require("../definitions/properties/MeasureDataItem"));

var UIContext_1 = __importDefault(require("../ui/UIContext"));

var ConditionalFormattingSpec_1 = require("../definitions/properties/ConditionalFormattingSpec");

var ColorUtil_1 = __importDefault(require("../utils/ColorUtil"));

var ConditionalFormatSpecHelper_1 = require("../definitions/properties/util/ConditionalFormatSpecHelper");

var QueryUtil_1 = __importDefault(require("../utils/QueryUtil")); // NOTE: DON'T CHANGE THE ORDER OF THE ITEMS IN THIS ARRAY. IF YOU DO, YOU WILL NEED TO CHANGE THE WHERE IT IS INDEXED


var ACTUAL_SLOT_IDX = 0;
var VALUES_SLOT_IDX = 1;
var GRID_COLS_SLOT_IDX = 2;
var GOAL_SLOT_IDX = 3;
var COLOR_SLOT_IDX = 4;
var SUPPORTED_SLOT_IDS = ['actual', 'values', 'grid_cols', 'goal', 'heat'];
var HEAT_SLOT_DEFAULT_ID = 'defaultHeatId'; // this is a id holder so that undo/redo can handled correctly between remove/add slot events

var SUPPORT_CONDITIONAL_FORMAT_VIS_TYPE = ['KPI', 'Crosstab', 'List'];

var ConditionalFormatting =
/** @class */
function (_super) {
  __extends(ConditionalFormatting, _super);

  function ConditionalFormatting(options) {
    var _this = _super.call(this) || this;

    _this._content = options.content;
    _this._Colors = options.features['Dashboard.Colors'];
    _this._CustomColor = options.features['Dashboard.CustomColor'];
    _this._internal = options.features['Dashboard.internal'];
    _this._Properties = options.features.Properties; // Hack for now to get to the propertiesManager since it is a dashboard service and and not a feature
    // At the time this instance is created, the propertiesManager had not been created yet so
    // save the dashboardAPI to enquire the propertiesManager when needed

    _this._dashboardAPI = options.dashboardAPI;
    _this._Icons = _this._dashboardAPI.getFeature('Icons');
    _this._dataSourceUI = _this._dashboardAPI.getFeature('DataSources.UI');

    _this._Properties.registerProvider(_this.getAPI());

    _this._CustomColor.registerProvider(_this.getAPI());

    _this._transaction = _this._dashboardAPI.getFeature('Transaction');
    _this._profile = _this._dashboardAPI.getAppConfig('profile');
    _this._providers = new Map(); // this is temporary until the featureManifest change is applied to the server and we can get the QueryService as a dependency.
    // I will remove this line at that time.

    _this._QueryService = _this._dashboardAPI.getFeature('QueryService');
    _this._slotMappingIsReady = null;

    _this._registerEvents();

    return _this;
  }

  ConditionalFormatting.prototype.getAPI = function () {
    if (!this._api) {
      this._api = APIFactory_1.default.createAPI(this, [ConditionalFormattingAPI_1.default]);
    }

    return this._api;
  };

  ConditionalFormatting.prototype.initialize = function () {
    return Promise.resolve();
  };

  ConditionalFormatting.prototype.registerProvider = function (name, provider) {
    if (!this._providers.has(name)) {
      this._providers.set(name, provider);
    }
  };

  ConditionalFormatting.prototype.deregisterProvider = function (name) {
    this._providers.delete(name);
  };

  ConditionalFormatting.prototype.destroy = function () {
    this._deregisterEvents();

    this._CustomColor.deregisterProvider(this.getAPI());

    this._Properties.deregisterProvider(this.getAPI());

    if (this._uiContext) {
      this._uiContext.destroy();

      this._uiContext = null;
    }

    if (this._conditionalFormattingState) {
      this._conditionalFormattingState.destroy();

      this._conditionalFormattingState = null;
    }

    this._ConditionalFormattingSpec = null;
  };

  ConditionalFormatting.prototype.isEnabled = function () {
    var visType = this._getVisualization().getType();

    return SUPPORT_CONDITIONAL_FORMAT_VIS_TYPE.includes(visType);
  };

  ConditionalFormatting.prototype.initializeFeature = function () {
    var _this = this;

    this._intializeFormattingState(); // perform any required queries


    return this._getMinMaxValuesOnInit().then(function () {
      // process the conditional palette
      return _this._processConditionalPalette();
    });
  };

  ConditionalFormatting.prototype.getFormatting = function (baseValue, targetValue, dataItemId) {
    if (!dataItemId) {
      throw new Error('Invalid dataItemId');
    }

    if (!underscore_1.isNumber(baseValue) || targetValue === null || !underscore_1.isNumber(targetValue)) {
      return null;
    }

    if (this._hasConditionalFormat(dataItemId)) {
      var formattingStyle = null;

      var condFormat = this._getFormat(dataItemId);

      if (this._isKpi() && !condFormat.hasMinMaxValues()) {
        condFormat.setMinMaxValues(baseValue, targetValue); // Since the maxValue have changed so adjust the rule condition default values

        this._adjustRulesValue(condFormat,
        /* adjustDefaultValuesOnly */
        true);
      }

      var uiContext = this._getUiContext();

      var validRule = this._findValidRule(condFormat, baseValue, targetValue);

      var ruleStyle = validRule && validRule.getRuleStyle();

      if (ruleStyle) {
        var paletteColors = uiContext.getPaletteColorsForPaletteId(condFormat.getPaletteId());
        var textColor = ColorUtil_1.default.getHexColorOrFillFromColorId(uiContext.getColors(), paletteColors, ruleStyle.getTextColor());
        formattingStyle = {
          color: textColor.pattern ? textColor.color : textColor,
          // return an iconId as shapeId since it is being consumed by visualizations/renderer/common/LabeledValueView.js to render the shapeId as an icon in the UI
          // @todo visualizations/renderer/common/LabeledValueView.js should be using iconId since shapeId is misleading
          shapeId: this._getIconId(ruleStyle.getShape())
        };

        if (!this._isKpi()) {
          var fillColor = ColorUtil_1.default.getHexColorOrFillFromColorId(uiContext.getColors(), paletteColors, ruleStyle.getFillColor());

          if (textColor.pattern && !fillColor.pattern) {
            fillColor = {
              fill: fillColor,
              pattern: textColor.pattern
            };
          }

          var background = ColorUtil_1.default.getRgbaColorFromHexColor(fillColor.pattern ? fillColor.fill : fillColor, condFormat.getBackgroundOpacity());
          formattingStyle = __assign(__assign({}, ColorUtil_1.default.getColorStyle(fillColor.color, background, fillColor.pattern)), formattingStyle);
        }
      }

      return formattingStyle;
    }

    return null;
  };

  ConditionalFormatting.prototype.getPropertyLayoutList = function () {
    var _this = this;

    var propertyLayoutList;

    if (this.isEnabled()) {
      this._intializeFormattingState();

      var uiContext = this._getUiContext();

      propertyLayoutList = [{
        id: 'color',
        type: 'Section',
        label: StringResources_1.default.get('sectionName_colorPalette'),
        position: 1
      }];
      propertyLayoutList.push({
        id: 'conditionalColors',
        editor: {
          sectionId: 'visualization.color',
          label: StringResources_1.default.get('sectionName_colorPalette'),
          position: 2,
          uiControl: {
            module: 'dashboard-analytics/features/content/conditionalFormatting/ConditionalFormatting',
            moduleClass: 'ConditionalColor',
            uiContext: uiContext
          }
        }
      });

      if (this._profile && this._profile.length) {
        propertyLayoutList.forEach(function (item) {
          item.profile = [_this._profile];
        });
      }
    } else {
      propertyLayoutList = [];
    }

    return propertyLayoutList;
  };

  ConditionalFormatting.prototype.getConditionalFormatMeasures = function () {
    var columns = [];

    var condFormattingSpec = this._getConditionalFormattingSpec();

    if (condFormattingSpec) {
      var dataItems = this._getSlotDataItems();

      dataItems.forEach(function (dataItem) {
        var measure = new MeasureDataItem_1.default({
          dataItemId: dataItem.getColumnId(),
          label: dataItem.getLabel()
        });
        columns.push(measure);
      });
    }

    return columns;
  };

  ConditionalFormatting.prototype.setColorBy = function (dataItemId, colorByDataItemId) {
    var condFormat = this._getFormat(dataItemId); // update the color slot.


    this._updateColorSlotInContentModel(condFormat, colorByDataItemId);

    condFormat.setColorBy(colorByDataItemId); // get min/max values

    this._getMinMaxValues(condFormat);

    var action = 'setColorBy';

    this._updateUIAndContentModel({
      dataItemId: dataItemId,
      action: action,
      value: colorByDataItemId
    },
    /* updateContentModel */
    true);
  };

  ConditionalFormatting.prototype.getColorBy = function (dataItemId) {
    var condFormat = this._getFormat(dataItemId);

    return condFormat.getColorBy();
  };

  ConditionalFormatting.prototype.setScale = function (dataItemId, value) {
    var condFormat = this._getFormat(dataItemId);

    condFormat.setScale(value);

    if (!condFormat.getHeatId()) {
      // update the color slot.
      this._updateColorSlotInContentModel(condFormat, condFormat.getColorBy());
    } // get min/max values


    if (!condFormat.hasMinMaxValues()) {
      this._getMinMaxValues(condFormat);
    } // user switched scale, recalculate values based on scale type


    this._adjustRulesValue(condFormat,
    /* adjustDefaultValuesOnly */
    false);

    var action = Actions_1.ACTIONS.SET_SCALE;

    this._updateUIAndContentModel({
      dataItemId: dataItemId,
      action: action,
      value: value
    },
    /* updateContentModel */
    true);
  };

  ConditionalFormatting.prototype.getScale = function (dataItemId) {
    var condFormat = this._getFormat(dataItemId);

    return condFormat.getScale();
  };

  ConditionalFormatting.prototype.setPaletteId = function (dataItemId, value) {
    var condFormat = this._getFormat(dataItemId);

    condFormat.setPaletteId(value);
    var action = Actions_1.ACTIONS.SET_PALETTE_ID;

    this._updateUIAndContentModel({
      dataItemId: dataItemId,
      action: action,
      value: value
    },
    /* updateContentModel */
    true);
  };

  ConditionalFormatting.prototype.getPaletteId = function (dataItemId) {
    var condFormat = this._getFormat(dataItemId);

    return condFormat.getPaletteId();
  };

  ConditionalFormatting.prototype.getNumberOfRules = function (dataItemId) {
    var condFormat = this._getFormat(dataItemId);

    return condFormat.getNumberOfRules();
  };

  ConditionalFormatting.prototype.setBackgroundOpacity = function (dataItemId, value) {
    var condFormat = this._getFormat(dataItemId);

    condFormat.setBackgroundOpacity(value);
    var action = Actions_1.ACTIONS.SET_BACKGROUND_OPACITY;

    this._updateUIAndContentModel({
      dataItemId: dataItemId,
      action: action,
      value: value
    },
    /* updateContentModel */
    true);
  };

  ConditionalFormatting.prototype.getBackgroundOpacity = function (dataItemId) {
    var condFormat = this._getFormat(dataItemId);

    return condFormat.getBackgroundOpacity();
  };

  ConditionalFormatting.prototype.addRule = function (dataItemId, ruleIndex, newRule) {
    var condFormat = this._getFormat(dataItemId);

    ruleIndex = ruleIndex === -1 ? this.getNumberOfRules(dataItemId) : ruleIndex;
    var value = condFormat.addRule(ruleIndex, newRule);

    if (!condFormat.getHeatId()) {
      // update the color slot.
      this._updateColorSlotInContentModel(condFormat, condFormat.getColorBy());
    }

    if (!condFormat.hasMinMaxValues()) {
      // get min/max values
      this._getMinMaxValues(condFormat);
    }

    var action = Actions_1.ACTIONS.ADD_RULE;

    this._updateUIAndContentModel({
      dataItemId: dataItemId,
      action: action,
      value: value,
      ruleIndex: ruleIndex
    },
    /* updateContentModel */
    true);
  };

  ConditionalFormatting.prototype.deleteRule = function (dataItemId, value) {
    var condFormat = this._getFormat(dataItemId);

    if (condFormat.deleteRule(value)) {
      var action = Actions_1.ACTIONS.DELETE_RULE;

      this._updateUIAndContentModel({
        dataItemId: dataItemId,
        action: action,
        value: value
      },
      /* updateContentModel */
      true);
    }
  };

  ConditionalFormatting.prototype.moveRule = function (dataItemId, value, ruleIndex) {
    var condFormat = this._getFormat(dataItemId);

    if (condFormat.moveRule(value, ruleIndex)) {
      var action = Actions_1.ACTIONS.MOVE_RULE;

      this._updateUIAndContentModel({
        dataItemId: dataItemId,
        action: action,
        value: value,
        ruleIndex: ruleIndex
      },
      /* updateContentModel */
      true);
    }
  };

  ConditionalFormatting.prototype.getRules = function (dataItemId) {
    var condFormat = this._getFormat(dataItemId);

    return condFormat.getRules();
  };

  ConditionalFormatting.prototype.getRule = function (dataItemId, ruleIndex) {
    var condFormat = this._getFormat(dataItemId);

    return condFormat.getRule(ruleIndex);
  };

  ConditionalFormatting.prototype.setRangeOperator = function (dataItemId, ruleIndex, value) {
    var condFormat = this._getFormat(dataItemId);

    var endCondition = condFormat.setRangeOperator(ruleIndex, value);
    var action = Actions_1.ACTIONS.SET_RANGE_OPERATOR;

    this._updateUIAndContentModel({
      dataItemId: dataItemId,
      action: action,
      value: value,
      ruleIndex: ruleIndex,
      context: endCondition
    },
    /* updateContentModel */
    true);
  };

  ConditionalFormatting.prototype.getRangeOperator = function (dataItemId, ruleIndex) {
    var condFormat = this._getFormat(dataItemId);

    return condFormat.getRangeOperator(ruleIndex);
  };

  ConditionalFormatting.prototype.setRuleStartConditionType = function (dataItemId, ruleIndex, value) {
    var condFormat = this._getFormat(dataItemId);

    var rule = condFormat.getRule(ruleIndex);

    if (rule) {
      rule.setRuleStartConditionType(value);
      var action = Actions_1.ACTIONS.SET_START_CONDITION_TYPE;

      this._updateUIAndContentModel({
        dataItemId: dataItemId,
        action: action,
        value: value,
        ruleIndex: ruleIndex
      },
      /* updateContentModel */
      true);
    }
  };

  ConditionalFormatting.prototype.getRuleStartConditionType = function (dataItemId, ruleIndex) {
    var condFormat = this._getFormat(dataItemId);

    var rule = condFormat.getRule(ruleIndex);
    return rule ? rule.getRuleStartConditionType() : null;
  };

  ConditionalFormatting.prototype.setRuleStartConditionValue = function (dataItemId, ruleIndex, value) {
    var condFormat = this._getFormat(dataItemId);

    var rule = condFormat.getRule(ruleIndex);

    if (rule) {
      rule.setRuleStartConditionValue(value);
      var action = Actions_1.ACTIONS.SET_START_CONDITION_VALUE;

      this._updateUIAndContentModel({
        dataItemId: dataItemId,
        action: action,
        value: value,
        ruleIndex: ruleIndex
      },
      /* updateContentModel */
      true);
    }
  };

  ConditionalFormatting.prototype.getRuleStartConditionValue = function (dataItemId, ruleIndex) {
    var condFormat = this._getFormat(dataItemId);

    var rule = condFormat.getRule(ruleIndex);
    return rule ? rule.getRuleStartConditionValue() : null;
  };

  ConditionalFormatting.prototype.setRuleEndConditionType = function (dataItemId, ruleIndex, value) {
    var condFormat = this._getFormat(dataItemId);

    var rule = condFormat.getRule(ruleIndex);

    if (rule) {
      rule.setRuleEndConditionType(value);
      var action = Actions_1.ACTIONS.SET_END_CONDITION_TYPE;

      this._updateUIAndContentModel({
        dataItemId: dataItemId,
        action: action,
        value: value,
        ruleIndex: ruleIndex
      },
      /* updateContentModel */
      true);
    }
  };

  ConditionalFormatting.prototype.getRuleEndConditionType = function (dataItemId, ruleIndex) {
    var condFormat = this._getFormat(dataItemId);

    var rule = condFormat.getRule(ruleIndex);
    return rule ? rule.getRuleEndConditionType() : null;
  };

  ConditionalFormatting.prototype.setRuleEndConditionValue = function (dataItemId, ruleIndex, value) {
    var condFormat = this._getFormat(dataItemId);

    var rule = condFormat.getRule(ruleIndex);

    if (rule) {
      rule.setRuleEndConditionValue(value);
      var action = Actions_1.ACTIONS.SET_END_CONDITION_VALUE;

      this._updateUIAndContentModel({
        dataItemId: dataItemId,
        action: action,
        value: value,
        ruleIndex: ruleIndex
      },
      /* updateContentModel */
      true);
    }
  };

  ConditionalFormatting.prototype.getRuleEndConditionValue = function (dataItemId, ruleIndex) {
    var condFormat = this._getFormat(dataItemId);

    var rule = condFormat.getRule(ruleIndex);
    return rule ? rule.getRuleEndConditionValue() : null;
  };

  ConditionalFormatting.prototype.setRuleStyleTextColor = function (dataItemId, ruleIndex, value) {
    var condFormat = this._getFormat(dataItemId);

    var rule = condFormat.getRule(ruleIndex);

    if (rule) {
      rule.setRuleStyleTextColor(value);
      var action = Actions_1.ACTIONS.SET_RULE_STYLE_TEXT_COLOR;

      this._updateUIAndContentModel({
        dataItemId: dataItemId,
        action: action,
        value: value,
        ruleIndex: ruleIndex
      },
      /* updateContentModel */
      true);
    }
  };

  ConditionalFormatting.prototype.getRuleStyleTextColor = function (dataItemId, ruleIndex) {
    var condFormat = this._getFormat(dataItemId);

    var rule = condFormat.getRule(ruleIndex);
    return rule ? rule.getRuleStyleTextColor() : null;
  };

  ConditionalFormatting.prototype.setRuleStyleFillColor = function (dataItemId, ruleIndex, value) {
    var condFormat = this._getFormat(dataItemId);

    var rule = condFormat.getRule(ruleIndex);

    if (rule) {
      rule.setRuleStyleFillColor(value);
      var action = Actions_1.ACTIONS.SET_RULE_STYLE_FILL_COLOR;

      this._updateUIAndContentModel({
        dataItemId: dataItemId,
        action: action,
        value: value,
        ruleIndex: ruleIndex
      },
      /* updateContentModel */
      true);
    }
  };

  ConditionalFormatting.prototype.getRuleStyleFillColor = function (dataItemId, ruleIndex) {
    var condFormat = this._getFormat(dataItemId);

    var rule = condFormat.getRule(ruleIndex);
    return rule ? rule.getRuleStyleFillColor() : null;
  };

  ConditionalFormatting.prototype.setRuleStyleShape = function (dataItemId, ruleIndex, value) {
    var condFormat = this._getFormat(dataItemId);

    var rule = condFormat.getRule(ruleIndex);

    if (rule) {
      rule.setRuleStyleShape(value);
      var action = Actions_1.ACTIONS.SET_RULE_STYLE_SHAPE;

      this._updateUIAndContentModel({
        dataItemId: dataItemId,
        action: action,
        value: value,
        ruleIndex: ruleIndex
      },
      /* updateContentModel */
      true);
    }
  };

  ConditionalFormatting.prototype.getRuleStyleShape = function (dataItemId, ruleIndex) {
    var condFormat = this._getFormat(dataItemId);

    var rule = condFormat.getRule(ruleIndex);
    return rule ? rule.getRuleStyleShape() : null;
  };

  ConditionalFormatting.prototype.setSummaryFillColor = function (hexColor) {
    this._ConditionalFormattingSpec.setSummaryFillColor(hexColor);

    var action = Actions_1.ACTIONS.SET_SUMMARY_FILL_COLOR;

    var value = this._ConditionalFormattingSpec.getSummaryFillColor();

    this._updateUIAndContentModel({
      action: action,
      value: value
    },
    /* updateContentModel */
    true);
  };

  ConditionalFormatting.prototype.getSummaryFillColor = function () {
    return this._ConditionalFormattingSpec.getSummaryFillColor();
  };

  ConditionalFormatting.prototype.getConditionalFormatting = function () {
    return this._getConditionalFormattingSpec().getContentModelJsonSpec();
  };

  ConditionalFormatting.prototype.getShapeDefinition = function (shape) {
    return IconsMap_1.default.getShapeDefinition(this._Icons, shape);
  };

  ConditionalFormatting.prototype.getDataItemFormatSpec = function (dataItemId) {
    var spec = {};

    var condFormat = this._getFormat(dataItemId);

    if (condFormat) {
      var colorBy_1 = condFormat.getColorBy();
      var dataItems = void 0;

      if (this._isKpi()) {
        // get the target slot dataItems
        dataItems = this._getSlotDataItems(SUPPORTED_SLOT_IDS[GOAL_SLOT_IDX]);
      } else {
        // get the color slot dataItems
        dataItems = this._getSlotDataItems(SUPPORTED_SLOT_IDS[COLOR_SLOT_IDX]);
      }

      var dataItem = dataItems.find(function (dataItem) {
        return dataItem.getColumnId() === colorBy_1;
      });

      if (dataItem) {
        spec = dataItem.getFormat(); // If the scale is percent we want to ensure our labels get formatted correctly

        if (condFormat.getScale() === RuleConstants_1.RULE_SCALES.PERCENTAGE) {
          spec.type = 'percent'; // This ensures the value we send to the formatter doesn't get multiplied by 100

          spec.convertPercent = false;
        }
      } else {
        console.log('getDataItemFormatSpec: unable to find dataItem API for column Id ' + dataItemId);
      }
    }

    return spec;
  };

  ConditionalFormatting.prototype.getCustomColorList = function () {
    var _this = this;

    var customColorList = [];

    if (this._conditionalFormattingState && this.isEnabled()) {
      var condFormats = this._getConditionalFormattingSpec().getConditionalFormats();

      var colorsApi_1 = this._Colors;
      condFormats.forEach(function (condFormat) {
        var rules = condFormat.getRules();
        rules.forEach(function (rule) {
          var colorId = rule.getRuleStyleTextColor();

          if (_this._isCustomColor(colorId)) {
            customColorList.push(colorsApi_1.getHexColorFromClassName(colorId));
          }

          colorId = rule.getRuleStyleFillColor();

          if (_this._isCustomColor(colorId)) {
            customColorList.push(colorsApi_1.getHexColorFromClassName(colorId));
          }
        });
      });
    }

    return underscore_1.uniq(customColorList);
  };

  ConditionalFormatting.prototype.getProvider = function () {
    return this._profile ? this._providers.get(this._profile) : null;
  };

  ConditionalFormatting.prototype.slotMappingIsReady = function () {
    return this._slotMappingIsReady !== null ? this._slotMappingIsReady : Promise.resolve();
  };

  ConditionalFormatting.prototype._getFormat = function (dataItemId, bCreate) {
    if (bCreate === void 0) {
      bCreate = false;
    }

    if (!dataItemId) {
      throw new Error('Invalid dataItemId');
    }

    var condFormat = this._getConditionalFormattingSpec().getConditionalFormatById(dataItemId, bCreate);

    if (!condFormat) {
      throw new Error("Invalid conditionaFormat during _getFormat call for " + dataItemId);
    }

    return condFormat;
  };

  ConditionalFormatting.prototype._applyModelChangeInUI = function (context) {
    this._conditionalFormattingState.applyModelChanges(context);
  };

  ConditionalFormatting.prototype._calculatePercentValue = function (baseValue, targetValue) {
    if (baseValue === 0 && targetValue === 0) {
      return 100;
    } else if (targetValue === null || targetValue === 0) {
      return null;
    }

    return (baseValue - targetValue) / Math.abs(targetValue) * 100 + 100;
  };

  ConditionalFormatting.prototype._executeRuleExpression = function (valueA, operator, valueB) {
    return eval(valueA + ' ' + operator + ' ' + valueB);
  };

  ConditionalFormatting.prototype._findValidRule = function (condFormat, baseValue, targetValue) {
    var _this = this;

    var rules = condFormat.getRules() || [];
    var scale = condFormat.getScale();
    var value;

    if (scale === RuleConstants_1.RULE_SCALES.PERCENTAGE) {
      value = this._calculatePercentValue(baseValue, targetValue);
    } else {
      value = this._isKpi() ? baseValue : targetValue;
    } // todo: we might want to cache the result to improve performance?


    var validRule = rules.find(function (rule) {
      var result;
      var startCondition = rule.getStartCondition(); // A condition type can be undefined

      if (startCondition && startCondition.getType()) {
        var startConditionValue = startCondition.getValue();
        var operator = startCondition.getType();

        if (startCondition.getType() === RuleConstants_1.RULE_OPERATORS.missing) {
          // todo: how to determine if the value is missing
          // Currently _executeRuleExpression will throw expression for these operators
          return value === null;
        }

        if (startCondition.getType() === RuleConstants_1.RULE_OPERATORS.inTop || startCondition.getType() === RuleConstants_1.RULE_OPERATORS.inBottom) {
          var range = condFormat.getMaxValue() - condFormat.getMinValue();
          operator = RuleConstants_1.RULE_OPERATORS.lessThanOrEqualTo;
          value = startCondition.getType() === RuleConstants_1.RULE_OPERATORS.inTop ?
          /* 100 - */
          _this._calculatePercentValue(condFormat.getMaxValue() - targetValue, range) : _this._calculatePercentValue(targetValue - condFormat.getMinValue(), range);
        }

        result = _this._executeRuleExpression(value, operator, startConditionValue);
      }

      if (rule.getRuleType() === RuleConstants_1.RULE_TYPES.RANGE) {
        var endCondition = rule.getEndCondition();

        if (endCondition && endCondition.getType() && rule.getOperator()) {
          var endConditionResult = _this._executeRuleExpression(value, endCondition.getType(), endCondition.getValue());

          return _this._executeRuleExpression(result, rule.getOperator(), endConditionResult);
        }
      }

      return result;
    });
    return validRule;
  };

  ConditionalFormatting.prototype._processConditionalPalette = function () {
    var paletteResolvers = [];

    var uiContext = this._getUiContext();

    var conditionalFormats = this._getConditionalFormattingSpec().getConditionalFormats();

    var paletteIds = [ConditionalFormatSpecHelper_1.DEFAULT_PALETTE_ID];
    conditionalFormats.forEach(function (condFormat) {
      if (!paletteIds.includes(condFormat.getPaletteId())) {
        paletteIds.push(condFormat.getPaletteId());
      }
    });
    paletteIds.forEach(function (paletteId) {
      paletteResolvers.push(uiContext.getColorPalette(paletteId));
    });
    return Promise.all(paletteResolvers);
  };

  ConditionalFormatting.prototype._getIconId = function (shape) {
    if (!shape || shape === 'none') {
      return undefined;
    }

    var shapeDef = this.getShapeDefinition(shape);
    return shapeDef ? shapeDef.iconId : undefined;
  };
  /**
   * We only expose one property in the model as a big JSON.  This method will update that
   * JSON with the latest information found in the _ConditionalFormatsModelSpec memeber property
   */


  ConditionalFormatting.prototype._updateConditionalFormatsModelSpec = function (setOptions) {
    this._getContentModel().setConditionalFormatting(this._getConditionalFormattingSpec().getContentModelJsonSpec(), setOptions);
  };

  ConditionalFormatting.prototype._getVisualization = function () {
    if (!this._visualization) {
      this._visualization = this._content.getFeature('Visualization');
    }

    return this._visualization;
  };

  ConditionalFormatting.prototype._getContentModel = function () {
    if (!this._contentModel) {
      var layoutModel = this._internal.getBoardModel().layout.findModel(this._content.getId());

      if (layoutModel) {
        this._contentModel = this._internal.getBoardModel().layout.findModel(this._content.getId()).getContentModel();
      }
    }

    return this._contentModel;
  };

  ConditionalFormatting.prototype._getSlotDataItems = function (slotId) {
    var _this = this;

    var visType = this._getVisualization().getType();

    var dataItems;

    if (!slotId) {
      switch (visType) {
        case 'Crosstab':
          slotId = SUPPORTED_SLOT_IDS[VALUES_SLOT_IDX];
          break;

        case 'List':
          slotId = SUPPORTED_SLOT_IDS[GRID_COLS_SLOT_IDX];
          break;

        default:
          // KPI case
          slotId = SUPPORTED_SLOT_IDS[ACTUAL_SLOT_IDX];
          break;
      }
    }

    dataItems = this._visualization && this._visualization.getSlots().getSlot(slotId).getDataItemList();
    dataItems = dataItems.filter(function (item) {
      return _this._isValidForCondFormat(item);
    });
    return dataItems;
  };

  ConditionalFormatting.prototype._getUiContext = function () {
    if (!this._uiContext) {
      var colors = this._Colors;
      var icons = this._Icons;

      var conditionalFormattingState = this._getConditionalFormattingState();

      var dataSourceUI = this._dataSourceUI;

      var contentId = this._content.getId();

      var dashboardApi = this._dashboardAPI;

      var condFormatApi = this._getUIConditionalFormattingApi();

      this._uiContext = new UIContext_1.default({
        condFormatApi: condFormatApi,
        colors: colors,
        icons: icons,
        conditionalFormattingState: conditionalFormattingState,
        dataSourceUI: dataSourceUI,
        contentId: contentId,
        dashboardApi: dashboardApi
      });
      var measures = this.getConditionalFormatMeasures();

      this._getUiContext().setMeasures(measures);
    }

    var visualization = this._getVisualization(); // When a vis has no slot mappings it is not associated with any data source and hence no sourceId


    var dataSource = visualization.getDataSource();

    this._uiContext.setDataSource(dataSource);

    var sourceId = dataSource ? visualization.getDataSource().getId() : null; // Always update the sourceId

    this._uiContext.setSourceId(sourceId);

    return this._uiContext;
  };

  ConditionalFormatting.prototype._getConditionalFormattingSpec = function () {
    if (!this._ConditionalFormattingSpec) {
      var contentModel = this._getContentModel();

      var condFormatFromModel = contentModel && contentModel.getConditionalFormatting();
      this._ConditionalFormattingSpec = new ConditionalFormattingSpec_1.ConditionalFormattingSpec(condFormatFromModel, this._getVisualization().getType());
    }

    return this._ConditionalFormattingSpec;
  };

  ConditionalFormatting.prototype._getConditionalFormattingState = function () {
    if (!this._conditionalFormattingState) {
      throw new Error('this._conditionalFormattingState have not been created');
    }

    return this._conditionalFormattingState;
  };

  ConditionalFormatting.prototype._intializeFormattingState = function () {
    var _this = this;

    if (!this._conditionalFormattingState) {
      // Set up React State Model
      this._conditionalFormattingState = new ConditionalFormattingState_1.default(this._getUIConditionalFormattingApi(), this._getVisualization().getType(), this._getConditionalFormattingSpec());

      if (this._isKpi()) {
        // Create conditional format for KPI when it has both base and goal slot mappings
        // This case occurs when open a saved dasbhoard where the KPI already has both slot mapping
        var actualSlotDataItem = this._getSlotDataItems(SUPPORTED_SLOT_IDS[ACTUAL_SLOT_IDX]);

        if (actualSlotDataItem.length) {
          var condFormat = this._getFormat(actualSlotDataItem[0].getColumnId(), true);

          var goalSlotaDataItem = this._getSlotDataItems(SUPPORTED_SLOT_IDS[GOAL_SLOT_IDX]);

          if (goalSlotaDataItem.length) {
            condFormat.setColorBy(goalSlotaDataItem[0].getColumnId());
          } else {
            this._resetKpiMinMaxBaseOnTargetValue(condFormat, this._content.getPropertyValue('targetValue'));
          }
        }
      } else {
        // Modify the colorBy for conditional formats using the heat slot id since it is the color slot mapping. If there is no
        // heat slot id, use the conditional format id since that is the default
        var condFormats = this._ConditionalFormattingSpec.getConditionalFormats();

        condFormats.forEach(function (condFormat) {
          var heatId = condFormat.getHeatId();

          if (heatId) {
            var dataItem = _this._getVisualization().getSlots().getDataItem(heatId);

            condFormat.setColorBy(dataItem.getColumnId());
          } else {
            condFormat.setColorBy(condFormat.getDataItemId());
          }
        });
      }
    } else if (this.isEnabled()) {
      this._conditionalFormattingState.updateVisType(this._getVisualization().getType());
    }
  };

  ConditionalFormatting.prototype._getUIConditionalFormattingApi = function () {
    if (!this._internalApi) {
      this._internalApi = APIFactory_1.default.createAPIFromSpec([{
        implementation: this,
        interface: ConditionalFormattingAPI_1.default
      }, {
        implementation: this,
        interface: UIConditionalFormattingAPI_1.default
      }]);
    }

    return this._internalApi;
  };
  /**
  * Adjust the rule values to represent the new scale type
  *
  * @param {ConditionalFormatSpec} condFormat The current conditional format in scope
  */


  ConditionalFormatting.prototype._adjustRulesValue = function (condFormat, adjustDefaultValuesOnly) {
    var _this = this;

    if (condFormat.hasMinMaxValues()) {
      var rules = condFormat.getRules();
      var scale_1 = condFormat.getScale();
      var minValue_1 = condFormat.getMinValue();
      var maxValue_1 = condFormat.getMaxValue();
      var dataItemId_1 = condFormat.getDataItemId();
      rules.forEach(function (rule, ruleIndex) {
        var action;
        var condition = rule.getStartCondition();

        var value = _this._adjustConditionValue(condition, scale_1, minValue_1, maxValue_1, adjustDefaultValuesOnly);

        if (underscore_1.isNumber(value)) {
          // Only update the mst model
          action = Actions_1.ACTIONS.SET_START_CONDITION_VALUE;

          _this._updateUIAndContentModel({
            dataItemId: dataItemId_1,
            action: action,
            value: value,
            ruleIndex: ruleIndex
          },
          /* updateContentModel */
          false);
        }

        condition = rule.getEndCondition();
        value = _this._adjustConditionValue(condition, scale_1, minValue_1, maxValue_1, adjustDefaultValuesOnly);

        if (underscore_1.isNumber(value)) {
          // Only update the mst model
          action = Actions_1.ACTIONS.SET_END_CONDITION_VALUE;

          _this._updateUIAndContentModel({
            dataItemId: dataItemId_1,
            action: action,
            value: value,
            ruleIndex: ruleIndex
          },
          /* updateContentModel */
          false);
        }
      });
    }
  };

  ConditionalFormatting.prototype._adjustConditionValue = function (condition, scale, minValue, maxValue, adjustDefaultValuesOnly) {
    var value;

    if (condition) {
      if (adjustDefaultValuesOnly || !condition.hasValue()) {
        // Set the new default value base on scale
        condition.setDefaultValue(scale, minValue, maxValue);
        value = condition.getValue();
      } else if (condition.hasValue()) {
        if (scale === RuleConstants_1.RULE_SCALES.NUMERIC) {
          value = Math.abs(maxValue) * (condition.getValue() / 100);
        } else {
          value = condition.getValue() / Math.abs(maxValue) * 100;
        }

        condition.setValue(value);
      }
    }

    return value;
  };

  ConditionalFormatting.prototype._registerEvents = function () {
    this._content.on('change:visualization:type', this._onChangeVisType.bind(this));

    this._content.on('change:visualization:slots:dataitems:addMapping', this._onAddSlotMapping.bind(this), this);

    this._content.on('change:visualization:slots:dataitems:removeMapping', this._onRemoveSlotMapping.bind(this), this); // Not sure if headless server has a canvas or not so put condtion check here just to be safe


    this._content.on('change:property:targetValue', this._onContentPropertyChange.bind(this), this);
  };

  ConditionalFormatting.prototype._deregisterEvents = function () {
    this._content.off('change:visualization:type', this._onChangeVisType.bind(this));

    this._content.off('change:visualization:slots:dataitems:addMapping', this._onAddSlotMapping.bind(this), this);

    this._content.off('change:visualization:slots:dataitems:removeMapping', this._onRemoveSlotMapping.bind(this), this); // Not sure if headless server has a canvas or not so put condtion check here just to be safe


    this._content.off('change:property:targetValue', this._onContentPropertyChange.bind(this), this);
  };
  /**
   * @description listen to the change vis type event
   * @param event
   */


  ConditionalFormatting.prototype._onChangeVisType = function () {
    if (this.isEnabled()) {
      this.initializeFeature();
    }
  };
  /**
  * Create a conditional format for each projected measure and mark as active. For KPI, manage the ColorBy since it can not be set explicitly
  *
  * @param {Object} event The event payload
  */


  ConditionalFormatting.prototype._onAddSlotMapping = function (event) {
    var _this = this;

    if (this._conditionalFormattingState && this.isEnabled()) {
      var info_1 = event && event.info;
      var slotIdx_1 = SUPPORTED_SLOT_IDS.findIndex(function (slot) {
        return slot === info_1.slotId;
      });

      var visType_1 = this._getVisualization().getType();

      if (info_1 && info_1.dataItemIdList && slotIdx_1 !== -1) {
        info_1.dataItemIdList.forEach(function (id) {
          var newDataItem = _this._getVisualization().getSlots().getDataItem(id);

          if (_this._isValidForCondFormat(newDataItem)) {
            var condFormat = void 0;
            var dataItemId = void 0;
            var value = void 0;

            if (!_this._isKpi()) {
              // if an add mapping is happening from the color slot, if might be part of remove/add event chain triggered by
              // undo so check for HEAT_SLOT_DEFAULT_ID then set properties accordingly
              if (slotIdx_1 === COLOR_SLOT_IDX) {
                var condFormats = _this._getConditionalFormattingSpec().getConditionalFormats();

                condFormat = condFormats.find(function (cf) {
                  return cf.getHeatId() === HEAT_SLOT_DEFAULT_ID;
                });

                if (condFormat) {
                  value = newDataItem.getColumnId();
                  dataItemId = condFormat.getDataItemId();
                  condFormat.setHeatId(newDataItem.getId());
                }
              } else {
                dataItemId = newDataItem.getColumnId();
                condFormat = _this._getFormat(dataItemId, true); // in case the data item was used in KPI

                condFormat = ConditionalFormatSpecHelper_1.ConditionalFormatSpecHelper.updateConditionalFormatSpecBasedOnVisType(visType_1, condFormat);
                condFormat.setActive(true); // We want to update the backgroundOpacity in the contentModel as well we only updated it in the spec

                var context = {
                  dataItemId: dataItemId,
                  action: Actions_1.ACTIONS.SET_BACKGROUND_OPACITY,
                  value: condFormat.getBackgroundOpacity()
                };

                _this._updateUIAndContentModel(context,
                /* updateContentModel */
                false);

                var measure = new MeasureDataItem_1.default({
                  dataItemId: newDataItem.getColumnId(),
                  label: newDataItem.getLabel()
                });

                _this._getUiContext().selectMeasureAddedToSlot(measure); // use the colorBy, it will be either the newDataItemId if a new cond format was created or a user modified one


                value = condFormat.getColorBy();
              }
            } else {
              var actualDataItems = _this._getSlotDataItems(SUPPORTED_SLOT_IDS[ACTUAL_SLOT_IDX]);

              var goalDataItems = _this._getSlotDataItems(SUPPORTED_SLOT_IDS[GOAL_SLOT_IDX]);

              var hasGoalSlotMapped = !!goalDataItems.length; // For KPI, the target slot is changed so get the current cond format and modify the colorBy property to represent it

              if (slotIdx_1 === GOAL_SLOT_IDX) {
                if (actualDataItems.length) {
                  dataItemId = actualDataItems[0].getColumnId();
                  condFormat = _this._getFormat(dataItemId);
                  value = newDataItem.getColumnId();
                }
              } else {
                // Base slot
                dataItemId = newDataItem.getColumnId();
                condFormat = _this._getFormat(dataItemId, true);
                var measure = new MeasureDataItem_1.default({
                  dataItemId: newDataItem.getColumnId(),
                  label: newDataItem.getLabel()
                });

                _this._getUiContext().selectMeasureAddedToSlot(measure);

                if (goalDataItems.length) {
                  value = goalDataItems[0].getColumnId();
                }
              }

              if (condFormat) {
                ConditionalFormatSpecHelper_1.ConditionalFormatSpecHelper.updateConditionalFormatSpecBasedOnVisType(visType_1, condFormat);

                if (slotIdx_1 === GOAL_SLOT_IDX) {
                  // The goal slot was mapped so reset its min/max value
                  condFormat.resetMinMaxValues();
                } else if (!hasGoalSlotMapped) {
                  _this._resetKpiMinMaxBaseOnTargetValue(condFormat, _this._content.getPropertyValue('targetValue'));
                }
              }
            }

            if (condFormat && value) {
              condFormat.setColorBy(value);
              var action = Actions_1.ACTIONS.SET_COLOR_BY;

              if (!(slotIdx_1 === COLOR_SLOT_IDX) && condFormat.getHeatId() && !(condFormat.getHeatId() === HEAT_SLOT_DEFAULT_ID)) {
                _this._updateColorSlotInContentModel(condFormat, value, event.transactionToken);
              }

              _this._updateUIAndContentModel({
                dataItemId: dataItemId,
                action: action,
                value: value
              },
              /* updateContentModel */
              true);
            }
          }
        });
      }

      this._onCompleteSlotMapping();
    }
  };
  /**
  * Modify conditional format for each projected measure and mark as not active
  *
  * @param {Object} event The event payload
  * @param {string} type The type of action to perform
  */


  ConditionalFormatting.prototype._onRemoveSlotMapping = function (event) {
    var _this = this;

    if (this._conditionalFormattingState && this.isEnabled()) {
      var info_2 = event && event.info;
      var slotIdx_2 = SUPPORTED_SLOT_IDS.findIndex(function (slot) {
        return slot === info_2.slotId;
      });

      if (info_2 && info_2.dataItemIdList && slotIdx_2 !== -1) {
        info_2.dataItemIdList.forEach(function (id) {
          var deletedDataItem = _this._getVisualization().getSlots().getDataItem(id); // For KPI, the target slot is changed so get the current cond format and modify the colorBy property to represent it


          if (_this._isKpi() && slotIdx_2 === GOAL_SLOT_IDX) {
            var dataItems = _this._getSlotDataItems();

            if (dataItems.length) {
              var dataItemId = dataItems[0].getColumnId();

              var condFormat = _this._getFormat(dataItemId);

              _this._resetKpiMinMaxBaseOnTargetValue(condFormat, _this._content.getPropertyValue('targetValue'));

              var value = undefined;
              condFormat.setColorBy(value);
              var action = Actions_1.ACTIONS.SET_COLOR_BY;

              _this._updateUIAndContentModel({
                dataItemId: dataItemId,
                action: action,
                value: value
              },
              /* updateContentModel */
              false);
            }
          } else if (slotIdx_2 === COLOR_SLOT_IDX) {
            // The colorBy setting in Conditional Formatting
            // find the condFormat with this heat id, set it. Since this remove event might be the first of remove/add event chain
            // triggered by undo, set the heat id to a default id which is then used in the add mapping event. Replace the
            // colorBy with the cond format id incase there is no add event to follow.
            var condFormats = _this._getConditionalFormattingSpec().getConditionalFormats();

            var condFormat = condFormats.find(function (cf) {
              return cf.getHeatId() === deletedDataItem.getId() && cf.isActive();
            });

            if (condFormat) {
              var dataItemId = condFormat.getDataItemId();
              condFormat.setColorBy(condFormat.getDataItemId());
              condFormat.setHeatId(HEAT_SLOT_DEFAULT_ID);
              var value = condFormat.getColorBy();
              var action = Actions_1.ACTIONS.SET_COLOR_BY;

              _this._updateUIAndContentModel({
                dataItemId: dataItemId,
                action: action,
                value: value
              },
              /* updateContentModel */
              true);
            }
          } else if (_this._hasConditionalFormat(deletedDataItem.getColumnId())) {
            // If the the data item was part of conditional formatting then remove it
            // else ignore since LW sends this event for all data items removed from slot mapping regardless
            // of whether or not the data item was used in Conditional Formatting
            // so only set its status to inactive when found
            var condFormat = _this._getFormat(deletedDataItem.getColumnId());

            condFormat.setActive(false);

            _this._updateColorSlotInContentModel(condFormat, null, event.transactionToken);

            _this._updateConditionalFormatsModelSpec();
          }
        });
      }

      this._onCompleteSlotMapping();
    }
  };
  /**
  * Checks if a dataitem is valid to be used for conditional formatting. This method should be extended if other validation cases are needed
  *
  * @param {Object} dataItem the dataItem to validate
  */


  ConditionalFormatting.prototype._isValidForCondFormat = function (dataItem) {
    var valid = true;

    var visType = this._getVisualization().getType();

    if (visType === 'List') {
      valid = dataItem.getType() === 'fact';
    }

    return valid;
  };
  /**
  * Update the color slot by substituting previous dataItem with the current dataItem
  *
  * @param {Object} condFormat the current conditional format
  * @param {string} newColumnId the current dataItem to add
  * @param {Object} transactionToken [Optional] Transaction token id
  */


  ConditionalFormatting.prototype._updateColorSlotInContentModel = function (condFormat, newColumnId, transactionToken) {
    if (!this._isKpi()) {
      var localTransactionToken = transactionToken ? transactionToken : this._transaction.startTransaction();

      var colorSlot_1 = this._getVisualization().getSlots().getSlot(SUPPORTED_SLOT_IDS[COLOR_SLOT_IDX]);

      if (!colorSlot_1) {
        throw new Error('Must have a color slot defined for this visualization');
      } // maintain measure order within color slot


      var measures = this._getSlotDataItems();

      var posIdx_1 = -1;
      measures.forEach(function (measure, idx) {
        if (measure.getColumnId() === condFormat.getDataItemId()) {
          if (idx < colorSlot_1.getDataItemList().length) {
            posIdx_1 = idx;
          }

          return true;
        }

        return false;
      });

      var prevDataItems = this._getSlotDataItems(SUPPORTED_SLOT_IDS[COLOR_SLOT_IDX]); // check if previous dataItem is already in the slot then remove it


      var prevDataItem = prevDataItems.find(function (dataItem) {
        return dataItem.getId() === condFormat.getHeatId();
      });

      if (prevDataItem) {
        colorSlot_1.removeDataItems([prevDataItem.getId()], localTransactionToken);
      }

      if (newColumnId) {
        var dataItemList = colorSlot_1.addDataItems([{
          columnId: newColumnId
        }], posIdx_1, localTransactionToken);

        if (dataItemList) {
          condFormat.setHeatId(dataItemList[0].getId());
        }
      }

      if (!transactionToken) {
        this._transaction.endTransaction(localTransactionToken);
      }
    }
  };

  ConditionalFormatting.prototype._isCustomColor = function (colorId) {
    return colorId && this._Colors.isCustomColor(colorId);
  };

  ConditionalFormatting.prototype._updateUIAndContentModel = function (context, updateContentModel) {
    this._applyModelChangeInUI(context);

    if (updateContentModel) {
      this._updateConditionalFormatsModelSpec();
    }
  };

  ConditionalFormatting.prototype._getMinMaxValues = function (condFormat) {
    var _this = this;

    if (!this._isKpi()) {
      QueryUtil_1.default.getMinMaxValuesFromQuery(condFormat.getHeatId(), this._getVisualization(), this._dashboardAPI, this._content, this._QueryService).then(function (data) {
        if (data) {
          if (data.min || data.max) {
            if (condFormat.getMinValue() !== data.min || condFormat.getMaxValue() !== data.max) {
              condFormat.setMinMaxValues(data.min, data.max);
            }
          } else {
            // TODO: this message should be displayed but since we are pass the translation date, leaving it here as a reminder
            // const colorBy= condFormat.getColorBy();
            // this._dashboardAPI.showToast(StringResources.get('conditionalFormattingNoDataForColorBy'), { colorById: colorBy });
            condFormat.setMinMaxValues(RuleConstants_1.RULE_DEFAULT_MIN_VALUE, RuleConstants_1.RULE_DEFAULT_MAX_VALUE);
          }

          _this._setUIHasMinMax(condFormat);
        }
      });
    }
  };

  ConditionalFormatting.prototype._isKpi = function () {
    var visType = this._getVisualization().getType();

    return visType === 'KPI';
  };
  /**
  * Executes a query to get the min/max value for the conditional formats on initialization of the feature
  */


  ConditionalFormatting.prototype._getMinMaxValuesOnInit = function () {
    var _this = this;

    if (this._isKpi()) {
      return Promise.resolve();
    }

    var promises = [];

    var conditionalFormats = this._getConditionalFormattingSpec().getConditionalFormats();

    var visualization = this._getVisualization(); // we want to run the query if there is an InTop/InBottom rule because it is needed for rule evaluation. Additonally for
    // Numeric scale, if the user opens a saved dashboard with a Numeric scale and did an addRule()... the query doesn't
    // execute quick enough to get the default value before the rule is expanded. In the other cases where addRule() can be called,
    // a setScale() or a setColorBy() must be executed first, giving the query enough time to execute so that when addRule() is called,
    // the min/max values are set


    conditionalFormats.forEach(function (condFormat) {
      promises.push(condFormat.getHeatId() && !condFormat.hasMinMaxValues() ? QueryUtil_1.default.getMinMaxValuesFromQuery(condFormat.getHeatId(), visualization, _this._dashboardAPI, _this._content, _this._QueryService) : Promise.resolve(undefined));
    });
    return Promise.all(promises).then(function (results) {
      results.forEach(function (data, idx) {
        var condFormat = conditionalFormats[idx];

        if (data) {
          if (data.min || data.max) {
            if (condFormat.getMinValue() !== data.min || condFormat.getMaxValue() !== data.max) {
              condFormat.setMinMaxValues(data.min, data.max);

              _this._getUiContext().getConditionalFormatsModel();
            }
          } else {
            condFormat.setMinMaxValues(RuleConstants_1.RULE_DEFAULT_MIN_VALUE, RuleConstants_1.RULE_DEFAULT_MAX_VALUE);
          }

          _this._setUIHasMinMax(condFormat);
        }
      });
    });
  };
  /**
  * Set the hasMinMax flag in the UI so the addRule button is controlled based on execution of the query to get the min/max value only
  * for Numeric scale.
  *
  * @param {Object} condFormat the conditional format
  */


  ConditionalFormatting.prototype._setUIHasMinMax = function (condFormat) {
    var action = Actions_1.ACTIONS.SET_HAS_MIN_MAX;
    var dataItemId = condFormat.getDataItemId();
    var value = true;

    this._updateUIAndContentModel({
      dataItemId: dataItemId,
      action: action,
      value: value
    },
    /* updateContentModel */
    false);
  };

  ConditionalFormatting.prototype._hasConditionalFormat = function (dataItemId) {
    return this._getConditionalFormattingSpec().hasConditionalFormat(dataItemId);
  };

  ConditionalFormatting.prototype._onCompleteSlotMapping = function () {
    var _this = this; // Multiple add/remove slot events get trigger during build-up so
    // put a guard to process only the first one right after the browser is in idle mode when
    // slot mappings should have been completed so we can process the available measures for the vis


    if (this._slotMappingIsReady === null) {
      this._slotMappingIsReady = new Promise(function (resolve) {
        var eventId = underscore_1.uniqueId('slotMappingEventId_');
        _this._slotMappingEventId = eventId;
        setTimeout(function () {
          if (_this.isEnabled) {
            if (_this._slotMappingEventId === eventId) {
              var measures = _this.getConditionalFormatMeasures();

              _this._getUiContext().setMeasures(measures);
            } // TODO: this is being called too often because many mapping events are sent --- story to figure out why (https://jsw.ibm.com/browse/CADBLOC-1451)
            // when mapping changes happen, the min/max ranges can change accordingly to what changed in visualization, so have to retrieve them when needed


            var cfSpec = _this._getConditionalFormattingSpec();

            var conditionalFormats = cfSpec ? cfSpec.getConditionalFormats() : [];
            conditionalFormats.forEach(function (condFormat) {
              if (condFormat.isActive() && condFormat.getHeatId() && condFormat.hasMinMaxValues()) {
                condFormat.resetMinMaxValues();
              }
            });
          }

          resolve();
        }, 0);
      });

      this._slotMappingIsReady.then(function () {
        _this._slotMappingIsReady = null;
      });
    }
  };

  ConditionalFormatting.prototype._onContentPropertyChange = function (options) {
    if (options === void 0) {
      options = {};
    }

    if (!this._isKpi()) {
      return;
    } // The manual target value property name is 'targetValue'


    var info = options['info'] || {};
    var value = info['value'];

    var actualSlotDataItem = this._getSlotDataItems(SUPPORTED_SLOT_IDS[ACTUAL_SLOT_IDX]);

    if (actualSlotDataItem.length) {
      var condFormat = this._getFormat(actualSlotDataItem[0].getColumnId(), true);

      var goalSlotaDataItem = this._getSlotDataItems(SUPPORTED_SLOT_IDS[GOAL_SLOT_IDX]);

      var noTargetSlotMapping = !goalSlotaDataItem.length;

      if (noTargetSlotMapping) {
        // a value can be a string or a nummber or null
        // this event is not consistent in the value format given
        var numericValue = NaN; // Since this event can provide a value if null during undo/redo
        // and null is not a valid value

        if (value) {
          if (underscore_1.isString(value)) {
            // The string must contain a value, otherwise it is NaN as in R6
            if (value.length) {
              numericValue = Number(value);
            }
          } else {
            numericValue = value;
          }
        }

        this._resetKpiMinMaxBaseOnTargetValue(condFormat, numericValue);
      }
    }
  };

  ConditionalFormatting.prototype._resetKpiMinMaxBaseOnTargetValue = function (condFormat, value) {
    if (condFormat && this._isKpi()) {
      // If there is manual value in content properties use it if there is no heat slot
      // This represents the maxValue as in R6?
      var isValidValue = !isNaN(value);

      if (isValidValue) {
        var minValue = value >= 0 ? 0 : Number.NEGATIVE_INFINITY;
        var maxValue = value;
        condFormat.setMinMaxValues(minValue, maxValue); // Since the maxValue have changed so adjust the rule condition default values

        this._adjustRulesValue(condFormat,
        /* adjustDefaultValuesOnly */
        true);
      } else {
        condFormat.resetMinMaxValues();
      }

      this._getUiContext().setHasTargetValue(isValidValue);
    }
  };

  return ConditionalFormatting;
}(ConditionalFormattingAPISpec_1.default);

exports.default = ConditionalFormatting;
